import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-List-line",
  "use": "icon-List-line-usage",
  "viewBox": "0 0 860.81 476.3",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 860.81 476.3\" id=\"icon-List-line\"><defs></defs><title>List-line</title><g id=\"icon-List-line_图层_2\" data-name=\"图层 2\"><g id=\"icon-List-line_图层_1-2\" data-name=\"图层 1\"><polyline class=\"cls-1\" points=\"15 15 428.62 461.3 845.81 16.78\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol